import { useMemo } from 'react';
import { css, mediaQueries } from '@eti/styles';
import { vars } from '@etg/wings';
import { getCabins } from '../utils/cabin';
import SeatMapCabin from './SeatMapCabin';
import { jsx as _jsx } from "react/jsx-runtime";
const seatMapCabinLayoutWrapper = (cabinContentHeight, cabinLayoutpaddingBottomMobile, cabinLayoutpaddingBottomDesktop) => css`
  background-color: ${vars.colors.page.background.primary};
  height: ${cabinContentHeight}px;
  overflow-y: auto;
  padding-bottom: ${cabinLayoutpaddingBottomMobile}px;
  position: relative;

  @media ${mediaQueries.medium.up} {
    padding-bottom: max(${cabinLayoutpaddingBottomMobile}px, 30vh);
  }

  @media (min-width: 1200px) {
    padding-bottom: ${cabinLayoutpaddingBottomDesktop}px;
  }
`;
const generateKey = index => `cabin_${index}`;
const SeatMapCabinLayout = _ref => {
  var _currentSegment$carri;
  let {
    activeSegment,
    cabinContentHeight,
    cabinLayoutpaddingBottom,
    currentSegment,
    headerFooterHeight = 0,
    isRyanairInTrip,
    isSkipButtonFocused,
    onChange,
    onSkipButtonFocus,
    seatTravelers,
    selectedDeck = {
      label: 'mainDeck',
      value: 'mainDeck'
    }
  } = _ref;
  const cabins = useMemo(() => getCabins(currentSegment, selectedDeck), [currentSegment, selectedDeck]);
  const carrierNameLowerCase = currentSegment === null || currentSegment === void 0 || (_currentSegment$carri = currentSegment.carrier) === null || _currentSegment$carri === void 0 || (_currentSegment$carri = _currentSegment$carri.name) === null || _currentSegment$carri === void 0 ? void 0 : _currentSegment$carri.toLowerCase().replace(/[^a-z0-9]+(.)/g, (_, carrierName) => carrierName.toUpperCase());
  return /*#__PURE__*/_jsx("div", {
    className: seatMapCabinLayoutWrapper(cabinContentHeight, cabinLayoutpaddingBottom, headerFooterHeight),
    "data-testid": `seatMap-cabinLayout-${carrierNameLowerCase}`,
    id: `seatMap-cabinLayout-${carrierNameLowerCase}`,
    children: cabins === null || cabins === void 0 ? void 0 : cabins.map((cabin, index) => /*#__PURE__*/_jsx(SeatMapCabin, {
      activeSegment: activeSegment,
      carrier: currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment.carrier,
      isRyanairInTrip: isRyanairInTrip,
      isSkipButtonFocused: isSkipButtonFocused,
      onChange: onChange,
      onSkipButtonFocus: onSkipButtonFocus,
      seatTravelers: seatTravelers,
      ...cabin
    }, generateKey(index)))
  });
};
export default SeatMapCabinLayout;
//# sourceMappingURL=SeatMapCabinLayout.js.map